import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='OneShop Team' dateTime='2022-01-22' tag='Poshmark' title='How to Organize your Poshmark Closet'>
        <p>
          Having an organized Poshmark closet is one way to get your shop noticed and it always helps to boosts your
          listings to the top of the search rankings by sharing your listings. As a posh seller, how often do you
          organize your entire closet? Once a week? Once a day? Multiple times a day?
        </p>
        <p>
          It’s a lot of work but everyone in the Poshmark business knows that by organizing and refreshing your listings
          you are getting the best chance to attract potential buyers and increase your chances of selling your
          listings. In this blog, we’ll discuss more how to simplify organizing your Poshmark closet and how this will
          translate to long-term sales.
        </p>

        <h3>How to change your closet order</h3>
        <p>
          Nobody likes walking into a disorganized and messy store. Having everything cluttered and without a proper
          place is a major turn-off for buyers and can be a huge mistake for any seller. As a Poshmark seller, you need
          to take into account the small details that have a significant impact on your shop.
        </p>
        <p>
          Changing your closet order is simple you just have to open Poshmark and log into your account with any device
          (iPhone, Android, or even an Ipad and any kind of tablet) and follow these steps:
        </p>
        <ol>
          <li>Tap your username on the button-right of your home screen</li>
          <li>Tap My Closet</li>
          <li>
            Tap the two-arrow icon on the top-right of your listings (this will open the “Sort By” menu in a pop-up. You
            can select any sorting option here to re-arrange all the items in your closet.
          </li>
          <li>
            Select Just Shared on the “Sort By” menu. So you can manually share any item in your closet and move it to
            the top of your listings.
          </li>
          <li>
            Tap the Share icon next to My Followers. To instantly share the selected listings with your Poshmark
            followers and move them to the top of your closet.
          </li>
        </ol>
        <p>
          Now that we’ve discussed the basic steps to re-arrange the order of your whole closet, let’s go over another
          method that you can use to efficiently organize your listings to maximize your time and get noticed by
          potential buyers.
        </p>

        <h3>Bottom to top method on Poshmark</h3>
        <p>
          For this method, you will have to decide which listings will be moved to the top of your list and which will
          remain at the bottom. The single best way to do this is to do your research on what items are popular on the
          search results and organize your listings by popularity and demand. It’s not at all uncommon for sellers to
          overlook possible high-value goods (like luxury items) in their closet just because it’s stuck at the bottom
          of the list.
        </p>
        <p>
          Remember that the things that you list, re-list, or share in general will always automatically go to the top
          and that the ones that you first listed will stay at the bottom. Although different factors may affect how
          you’ll decide the order of your listings (such as the lowest listing price, new with tag or nwt, retail price,
          bundle discount, different categories, etc.) this is nonetheless an excellent method to keep in mind whenever
          you’re tackling reorganizing your closet.
        </p>

        <h3>Does closet ordering matter?</h3>
        <p>
          We’ve talked about how messy and unorganized closets can give the wrong impression on buyers but there’s a
          good chance that not all of them will turn away from your shop because of your lack of closet order.
        </p>

        <h4>Most sales are done through the Poshmark search bar</h4>
        <p>
          So does closet ordering matter in a way? yes and no because most sales are done with the primary intention of
          buyers to purchase a specific item using the search bar. Similar to other platforms like Instagram and Etsy
          users often don’t have a goal to browse shops at random.
        </p>
        <p>
          Instead, they have specific keywords or items in mind that they’d like to browse for using the search bar.
        </p>

        <h4>
          By maintaining a certain closet order, you are giving up constantly sharing, which is the best way to market
          your closet
        </h4>
        <p>
          However, don’t let this discourage you from organizing your closet. By maintaining a tidy and organized handle
          on your closet you are saving yourself a lot of time on constantly sharing and hunting down your listing that
          can appeal to potential buyers. Time is money after all and decisions can be made in seconds so either way, a
          sale can be lost by poor closet order.
        </p>

        <p>
          It’s not easy to always be updating your listings and organizing your closet but it has to be done or you risk
          losing potential sales. So save yourself time and adopt an easier and more efficient way to help you create
          categories and manage your listings and inventory like a pro. OneShop is an automation software specially
          designed to boost your sales by continuously sharing your market listings with potential buyers and create
          smart categories that make your inventory a breeze to find. Think of it as your own personal closet organizer
          and more! It also employs innovative and adoptive technology to change the share order with ease, it works
          24/7 with minimal supervision so you can check on your store’s progress all from your phone while you’re on
          the go.
        </p>
        <p>
          Try it for yourself, register for free, and enjoy a 7-day trial with no commitment or credit card required.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
